import { useContext, useState } from 'react';
import './NotifyMeLogin.scss'
import { GlobalContext } from '../../../context/GlobalContext';
import { useTranslation } from 'react-i18next';
import HeaderNavigation from '../../common/HeaderNavigation/HeaderNavigation';
import { Typography, Button, Input } from 'mobily-ui-library/lib';
import { ConfigProvider, Form } from "antd";



interface Props {
    handleSubmit: (fd: any) => void;
}

const NotifyMeLogin = ({ handleSubmit }: Props) => {
    const { state, dispatch }: any = useContext(GlobalContext);
    const { t } = useTranslation();
    const { rtl } = state;
    const direction = rtl ? 'rtl' : 'ltr';
    const [form] = Form.useForm();

    const [mobileValid, setMobileValid] = useState(false);
    const [mobileNumber, setMobileNumber] = useState('05');
    const [mobileNumberColor, setMobileNumberColor] = useState('blue');

     

    const handleMobileNumber = (e: any) => {
        const value = e.target.value;
        let newValue = value;
        if (newValue.indexOf('05') != 0) {
            newValue = '05'
        }
        form.setFieldsValue({
            mobileNumber: newValue
        });
        setMobileNumber(newValue);
        const regex = /^((05)([0-9]{8}))$/;
        if (regex.test(value)) {
            setMobileValid(true);
        } else {
            setMobileValid(false);
        }
    }

    const focusHandelMobileNumber = () => {
        if (!mobileNumber) {
            form.setFieldsValue({
                mobileNumber: '05'
            });
        }
        setMobileNumberColor('blue');
    }

    const focusOutHandelMobileNumber = () => {
        if (mobileNumber.length > 2) {
            const pattern = /^(((05)(5|0|3|6|4|9|1|8|7|2)([0-9]{7})))$/
            const result = pattern.test(mobileNumber);
            if (result) {
                setMobileNumberColor('blue');
            }
            else {
                setMobileNumberColor('red');
            }
        } else {
            setMobileNumberColor('blue');
        }
    }

    const handleHeaderCancel = () => {
        window.location.reload();
    };

    const onFinish = async (values: any) => {
        console.log(mobileNumberColor)
        dispatch({ type: 'LOADER', payload: { loading: true } });
        handleSubmit(values);
    };


    return (
        <div className='NotifyMeLogin__Container'>
            <HeaderNavigation
                rtl={rtl}
                percent={50}
                showBackArrow={false}
                handleHeaderCancel={handleHeaderCancel}
            />
            <section className='NotifyLogin'>
                <div className='NotifyLoginHeader'>
                    <Typography className='NotifyTitle'>{t('contact_information')}</Typography>
                    <Typography className='NotifySubTitle'> {t('receive_verification')}</Typography>
                </div>
                <ConfigProvider direction={direction}>
                    <Form form={form} className={rtl ? "SL__Form SL__right" : "SL__Form"} onFinish={onFinish}>
                        <Form.Item
                            hasFeedback
                            name='mobileNumber'
                            initialValue={mobileNumber}
                            className="EmailId__inputField"
                            rules={[
                                { required: true, message: t('Receiver_Phone_Number_is_Missing') },
                                {
                                    message: t('Not_a_Valid_Phone_Number'),
                                    pattern: /^((05)([0-9]{8}))$/
                                }
                            ]}
                        >
                            <Input
                                type="text"
                                maxLength={10}
                                value={mobileNumber}
                                id="mobilyNumber-input"
                                placeholder={t('OTP_sent_to_this_number')}
                                className="SL__FormInput"
                                headingleft={t('Phone_Number')}
                                onChange={handleMobileNumber}
                                onFocus={focusHandelMobileNumber}
                                onBlur={focusOutHandelMobileNumber}
                                labelleft={t('OTP_will_sent')}
                            />
                        </Form.Item>
                        <Form.Item
                            hasFeedback
                            name='email'
                            className='EmailId__inputField'
                            rules={[
                                {
                                    required: false,
                                    message: t("Enter_your_email")
                                },
                                {
                                    pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/,
                                    message: t("not_a_valid_email")
                                }
                            ]}
                        >
                            <Input
                                type="text"
                                id="emailInput"
                                placeholder={t('Enter_your_email')}
                                className="SL__FormInput"
                                headingleft={`${t("Email")} (${t('Optional')})`}
                                labelleft={t('your_valid_email_address')}
                            />
                        </Form.Item>
                        <Form.Item>
                            <Button
                                rtl={rtl}
                                className="SL_FormBtn"
                                htmlType={'submit'}
                                variant={mobileValid ? "default" : "disabled"}
                            >
                                {t('Continue')}
                            </Button>
                        </Form.Item>
                    </Form>
                </ConfigProvider>
            </section>

        </div>
    )
}

export default NotifyMeLogin


